import type { SemanticVersion, VersionRange } from '@ochal/module-sdk/contracts';

interface Version { major: number; minor: number; patch: number }
export function parseVersion(value: string): Version | null {
  const match = /^(\d+)\.(\d+)\.(\d+)(?:[-+].*)?$/.exec(value);
  return match ? { major: Number(match[1]), minor: Number(match[2]), patch: Number(match[3]) } : null;
}
function compare(left: Version, right: Version): number { return left.major - right.major || left.minor - right.minor || left.patch - right.patch; }
export function satisfiesVersion(versionValue: SemanticVersion | string, range: VersionRange): boolean {
  const version = parseVersion(versionValue);
  if (!version) return false;
  const trimmed = range.trim();
  if (trimmed === '*') return true;
  if (trimmed.startsWith('^')) {
    const minimum = parseVersion(trimmed.slice(1));
    if (!minimum || compare(version, minimum) < 0) return false;
    const maximum = minimum.major > 0 ? { major: minimum.major + 1, minor: 0, patch: 0 } : minimum.minor > 0 ? { major: 0, minor: minimum.minor + 1, patch: 0 } : { major: 0, minor: 0, patch: minimum.patch + 1 };
    return compare(version, maximum) < 0;
  }
  if (trimmed.startsWith('~')) {
    const minimum = parseVersion(trimmed.slice(1));
    return Boolean(minimum && compare(version, minimum) >= 0 && version.major === minimum.major && version.minor === minimum.minor);
  }
  return trimmed.split('||').some((candidate) => {
    const exact = parseVersion(candidate.trim());
    return Boolean(exact && compare(version, exact) === 0);
  });
}
